export default __webpack_public_path__ + "static/media/elementary-math.576bc119.svg";